import { memo } from "react";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import SvgIcon from "@mui/material/SvgIcon";

import { palette } from "../../theme/palette";

const useStyles = makeStyles({
  icon: {
    width: "1.5rem",
    height: "1.5rem",
    fillOpacity: "0.87",
  },
});

export const ExternalLinkIcon = memo(
  ({
    className,
    stroke = palette.typography.white.solid,
    strokeWidth = 1.5,
    ...props
  }) => {
    const styles = useStyles();

    return (
      <SvgIcon
        viewBox="0 0 24 24"
        className={clsx(styles.icon, className)}
        fill="none"
        {...props}
      >
        <path
          d="m10 6h-4c-1.10457 0-2 .89543-2 2v10c0 1.1046.89543 2 2 2h10c1.1046 0 2-.8954 2-2v-4m-4-10h6m0 0v6m0-6-10 10"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
      </SvgIcon>
    );
  }
);
